/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file-multiple': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M15 7h5.5L15 1.5V7M8 0h8l6 6v12a2 2 0 01-2 2H8a2 2 0 01-2-2V2a2 2 0 012-2M4 4v18h16v2H4a2 2 0 01-2-2V4h2z"/>'
  }
})
